import "../index.css";

export const Terms = (props) => {
  //const { onSubmit } = props;

  return (
    <div className="p-12 terms ">
      <p className="termsUpper mb-5">
        THIS IS THE BETA VERSION OF THE WAVGAME WHICH IS STILL BEING ACTIVELY
        DEVELOPED. YOU ACKNOWLEDGE THE INFORMATION AVAILABLE IS NOT INTENDED TO
        BE RELIED ON OR USED IN A PRODUCTION ENVIRONMENT. YOU ACKNOWLEDGE AND
        ACCEPT THAT THE SITE OR SERVICES (A) MAY CONTAIN BUGS, ERRORS, AND
        DEFECTS, (B) MAY FUNCTION IMPROPERLY OR BE SUBJECT TO PERIODS OF
        DOWNTIME AN UNAVAILABILITY, (C) MAY RESULT IN TOTAL OR PARTIAL LOSS OR
        CORRUPTION OF DATA OR FUNDS USED IN THE SITE, AND (D) MAY BE MODIFIED AT
        ANY TIME, INCLUDING THROUGH THE RELEASE OF SUBSEQUENT VERSIONS, ALL WITH
        OR WITHOUT NOTICE. THE SITE IS AVAILABLE ON AN “AS IS” AND “AS
        AVAILABLE” BASIS FOR THE SOLE PURPOSE OF COLLECTING FEEDBACK ON QUALITY,
        USABILITY, PERFORMANCE AND ANY DEFECTS. THANK YOU FOR YOUR SUPPORT WHILE
        WE CONTINUE TO WORK ON DELIVERING A PERFECT PRODUCT.
      </p>
      <p className="text-xl font-extrabold">Terms of Use</p>
      <p>Version 1.0</p>
      <p>Last revised on: May 23, 2023</p>
      <br></br>
      <p>
        Welcome to the WavGAME provided by WavWRLD (“ WavWRLD ”, “ Company ”, “
        we ”, “ our ”, or “ us ”). With WavGAME you can collect to connect with
        artists through a fun burn-to-win NFT experience. These terms of use (“
        Terms ”, “ Terms of Use ” or the “ Agreement ”) govern your use of the
        website located at www.wavwrld.xyz (the “ Site ”), and all related
        tools, applications, data, software, and other services provided by us
        (the “ Service ”). Certain features of the Site and Services may be
        subject to additional guidelines, terms, or rules, which will be posted
        on the Site in connection with such features. All such additional terms,
        guidelines, and rules are incorporated by reference into these Terms and
        constitute a legally binding agreement between you and Company in
        relation to your use of the Service. Any personal information submitted
        in connection with your use of the Service is subject to our Privacy
        Policy, which is hereby incorporated by reference into these Terms.
      </p>
      <br></br>
      <p>
        THESE TERMS SET FORTH THE LEGALLY BINDING TERMS AND CONDITIONS THAT
        GOVERN YOUR USE OF THE SITE AND SERVICES. BY ACCESSING OR USING THE SITE
        OR SERVICES, YOU ARE ACCEPTING THESE TERMS (ON BEHALF OF YOURSELF OR THE
        ENTITY THAT YOU REPRESENT), AND YOU REPRESENT AND WARRANT THAT YOU HAVE
        THE RIGHT, AUTHORITY, AND CAPACITY TO ENTER INTO THESE TERMS (ON BEHALF
        OF YOURSELF OR THE ENTITY THAT YOU REPRESENT). YOU FURTHER REPRESENT AND
        WARRANT THAT YOU ARE OTHERWISE LEGALLY PERMITTED TO USE THE SERVICES IN
        YOUR JURISDICTION AND THAT THE COMPANY IS NOT LIABLE FOR YOUR COMPLIANCE
        WITH SUCH APPLICABLE LAWS. YOU MAY NOT ACCESS OR USE THE SITE OR ACCEPT
        THE TERMS IF YOU ARE NOT AT LEAST 18 YEARS OLD. IF YOU DO NOT AGREE WITH
        ALL OF THE PROVISIONS OF THESE TERMS, DO NOT ACCESS AND/OR USE THE SITE
        AND SERVICES. THESE TERMS REQUIRE THE USE OF ARBITRATION (SECTION 13.2)
        ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR
        CLASS ACTIONS, AND ALSO LIMIT THE REMEDIES AVAILABLE TO YOU IN THE EVENT
        OF A DISPUTE.
      </p>
      <p className="termsUpper mt-3">
        <b>1. PLAY THE WAVGAME </b>
      </p>
      <p>
        1.1 User Responsibilities. In order to use certain features of the Site
        and Services, you must create an account with a third party provider
        e.g. Google which will also create a digital asset wallet. You
        acknowledge that Company is not responsible for transferring,
        safeguarding, or maintaining your private keys or any digital currency
        associated therewith. If you lose, mishandle, or have stolen associated
        digital currency private keys, you acknowledge that you may not be able
        to recover associated digital currency, and that Company is not
        responsible for such loss. You acknowledge that Company or Liquality is
        not responsible for any loss or damage arising from your failure to
        comply with the requirements hereunder. You will also need to create an
        account with a credit card.
      </p>{" "}
      <p>
        1.2 Buy music NFTs . You acknowledge that you will be charged for
        minting the level 1 music NFTs to start/continue the game. Any payments
        or financial transactions that you engage via the Site will be conducted
        solely through Crossmint. Please be aware of their own terms of use. We
        have no control over these payments or transactions, nor do we have the
        ability to reverse any payments or transactions. We have no liability to
        you or to any third party for any claims or damages that may arise as a
        result of any payments or transactions that you engage in via the Site,
        or any other payment. We do not provide refunds for any purchases that
        you might make on or through the Site – whether for WavGAME NFTs or
        anything else.
      </p>
      <p>
        1.3 Maximum amount for flight ticket. You acknowledge that if you win
        the final prize the maximum amount for the flight ticket to get to the
        event is $1,000 US Dollar. All costs above and beyond this must be borne
        by the winner.{" "}
      </p>
      <p>
        1.4 Company Discretion . Company has sole discretion to decide if you
        can or cannot create an account on our Site.{" "}
      </p>
      <p className="termsUpper mt-3">
        <b>2. ACCESS TO SITE AND SERVICES</b>
      </p>
      <p>
        2.1 License . Subject to these Terms, Company grants you a
        non-transferable, non-exclusive, revocable, limited license to use and
        access the Site and Services solely for your own personal, noncommercial
        use.
      </p>
      <p>
        2.2 Certain Restrictions. The rights granted to you in these Terms are
        subject to the following restrictions: (a) you shall not license, sell,
        rent, lease, transfer, assign, distribute, host, or otherwise
        commercially exploit the Site or Services, whether in whole or in part,
        or any content displayed on the Site or Services; (b) you shall not
        modify, make derivative works of, disassemble, reverse compile or
        reverse engineer any part of the Site or Services; (c) you shall not
        access the Site or Services in order to build a similar or competitive
        website, product, or service; (d) except as expressly stated herein, no
        part of the Site or Services may be copied, reproduced, distributed,
        republished, downloaded, displayed, posted or transmitted in any form or
        by any means; and (e) you shall not use the Site or Services other than
        as permitted hereunder. Unless otherwise indicated, any future release,
        update, or other addition to functionality of the Site and Services
        shall be subject to these Terms. All copyright and other proprietary
        notices on the Site (or on any content displayed on the Site) must be
        retained on all copies thereof.
      </p>
      <p>
        2.3 Modification. Company reserves the right, at any time, to modify,
        suspend, or discontinue the Site or Services (in whole or in part) with
        or without notice to you. You agree that Company will not be liable to
        you or to any third party for any modification, suspension, or
        discontinuation of the Site and Services or any part thereof.
      </p>
      <p>
        2.4 No Support or Maintenance. You acknowledge and agree that Company
        will have no obligation to provide you with any support or maintenance
        in connection with the Site and Services.
      </p>
      <p>
        2.5 Ownership. Excluding any User Content that you may provide (defined
        below), you acknowledge that all the intellectual property rights,
        including copyrights, patents, trademarks, and trade secrets, in the
        Site and Services and its content are owned by Company or Company’s
        suppliers. Neither these Terms (nor your access to the Site and
        Services) transfers to you or any third party any rights, title or
        interest in or to such intellectual property rights, except for the
        limited access rights expressly set forth in Section ‎2.1. Company and
        its suppliers reserve all rights not granted in these Terms. There are
        no implied licenses granted under these Terms.
      </p>
      <p className="termsUpper mt-3">
        <b>3. USER CONSENT</b>
      </p>
      <p>
        3.1 User Content. “User Content” means any and all information and
        content that a user submits to, or uses with, the Site and Services
        (e.g., content in the user’s profile or postings). You are solely
        responsible for your User Content. You assume all risks associated with
        use of your User Content, including any reliance on its accuracy,
        completeness or usefulness by others, or any disclosure of your User
        Content that personally identifies you or any third party. You hereby
        represent and warrant that your User Content does not violate our
        Acceptable Use Policy (defined in Section ‎3.3). You may not represent
        or imply to others that your User Content is in any way provided,
        sponsored or endorsed by Company. Because you alone are responsible for
        your User Content, you may expose yourself to liability if, for example,
        your User Content violates the Acceptable Use Policy. Company is not
        obligated to backup any User Content, and your User Content may be
        deleted at any time without prior notice. You are solely responsible for
        creating and maintaining your own backup copies of your User Content if
        you desire.
      </p>
      <p>
        3.2 License. You hereby grant (and you represent and warrant that you
        have the right to grant) to Company an irrevocable, non-exclusive,
        royalty-free and fully paid, worldwide license to reproduce, distribute,
        publicly display and perform, prepare derivative works of, incorporate
        into other works, and otherwise use and exploit your User Content, and
        to grant sublicenses of the foregoing rights, solely for the purposes of
        including your User Content in the Site and Services. You hereby
        irrevocably waive (and agree to cause to be waived) any claims and
        assertions of moral rights or attribution with respect to your User
        Content.
      </p>
      <p>
        3.3 Acceptable Use Policy. The following terms constitute our “
        Acceptable Use Policy ”:
      </p>
      <p>
        (a) You agree not to use the Site and Services to collect, upload,
        transmit, display, or distribute any User Content (i) that violates any
        third-party right, including any copyright, trademark, patent, trade
        secret, moral right, privacy right, right of publicity, or any other
        intellectual property or proprietary right; (ii) that is unlawful,
        harassing, abusive, tortious, threatening, harmful, invasive of
        another’s privacy, vulgar, defamatory, false, intentionally misleading,
        trade libelous, pornographic, obscene, patently offensive, promotes
        racism, bigotry, hatred, or physical harm of any kind against any group
        or individual or is otherwise objectionable; (iii) that is harmful to
        minors in any way; or (iv) that is in violation of any law, regulation,
        or obligations or restrictions imposed by any third party or
        governmental agency, including without limitation securities laws,
        commodities laws, money transmission regulations, and anti-money
        laundering and anti-terrorism laws.
      </p>
      <p>
        (b) In addition, you agree not to: (i) upload, transmit, or distribute
        to or through the Site or Services any computer viruses, worms, or any
        software intended to damage or alter a computer system or data; (ii)
        send through the Site or Services unsolicited or unauthorized
        advertising, promotional materials, junk mail, spam, chain letters,
        pyramid schemes, or any other form of duplicative or unsolicited
        messages, whether commercial or otherwise; (iii) use the Site or
        Services to harvest, collect, gather or assemble information or data
        regarding other users, including e-mail addresses, without their
        consent; (iv) interfere with, disrupt, or create an undue burden on
        servers or networks connected to the Site or Services, or violate the
        regulations, policies or procedures of such networks; (v) attempt to
        gain unauthorized access to the Site or Services (or to other computer
        systems or networks connected to or used together with the Site or
        Services), whether through password mining or any other means; (vi)
        harass or interfere with any other user’s use and enjoyment of the Site
        or Services; or (vi) use software or automated agents or scripts to
        produce multiple accounts on the Site or Services, or to generate
        automated searches, requests, or queries to (or to strip, scrape, or
        mine data from) the Site or Services (provided, however, that we
        conditionally grant to the operators of public search engines revocable
        permission to use spiders to copy materials from the Site or Services
        for the sole purpose of and solely to the extent necessary for creating
        publicly available searchable indices of the materials, but not caches
        or archives of such materials, subject to the parameters set forth in
        our robots.txt file).
      </p>
      <p>
        3.4 Enforcement. We reserve the right (but have no obligation) to review
        any User Content, and to investigate and/or take appropriate action
        against you in our sole discretion if you violate the Acceptable Use
        Policy or any other provision of these Terms or otherwise create
        liability for us or any other person. Such action may include removing
        or modifying your User Content, terminating your use, and/or reporting
        you to law enforcement authorities.
      </p>
      <p>
        3.5 Feedback. Should you encounter any bugs, glitches, lack of
        functionality or other problems on the website, please let us know
        immediately so we can rectify these accordingly. We appreciate your
        feedback as it helps us develop the platform and offer the best Service
        possible. If you provide Company with any feedback or suggestions
        regarding the Site or Services (“Feedback”), you hereby assign to
        Company all rights in such Feedback and agree that Company shall have
        the right to use and fully exploit such Feedback and related information
        in any manner it deems appropriate. Company will treat any Feedback you
        provide to Company as non-confidential and non-proprietary. You agree
        that you will not submit to Company any information or ideas that you
        consider to be confidential or proprietary.
      </p>
      <p>
        3.6 Rewards. Company from time to time, in its sole discretion, may
        decide to offer prizes to incentivize user participation, however, any
        reward or benefit offered by Company does not create, constitute, or
        give rise to any legal or contractual rights in users of the Site and
        Services. You acknowledge that Company has no legal obligation to
        provide rewards to any contributor.
      </p>
      <p className="termsUpper mt-3">
        <b>4. INDEMNIFICATION</b>
      </p>
      <p>
        You agree to indemnify and hold Company (and its directors, officers,
        employees, contractors, affiliates, representatives and agents)
        harmless, including costs and attorneys’ fees, from any claim or demand
        made by any third party due to or arising out of (a) your use of the
        Site and Services, (b) your violation of these Terms, (c) your violation
        of applicable laws or regulations or (d) your User Content. Company
        reserves the right, at your expense, to assume the exclusive defense and
        control of any matter for which you are required to indemnify us, and
        you agree to cooperate with our defense of these claims. You agree not
        to settle any matter without the prior written consent of Company.
        Company will use reasonable efforts to notify you of any such claim,
        action or proceeding upon becoming aware of it.
      </p>
      <p className="termsUpper mt-3">
        <b>5. THIRD PARTY LINKS & ADS; OTHER USERS</b>
      </p>
      <p>
        5.1 Third-Party Links & Ads. The Site and Services may contain links to
        third-party websites and services, including digital asset wallets,
        and/or display advertisements for third parties (collectively, “
        Third-Party Links & Ads ”). Such Third-Party Links & Ads are not under
        the control of Company, and Company is not responsible for any
        Third-Party Links & Ads. Company provides access to these Third-Party
        Links & Ads only as a convenience to you, and does not review, approve,
        monitor, endorse, warrant, or make any representations with respect to
        Third-Party Links & Ads. You use all Third-Party Links & Ads at your own
        risk, and should apply a suitable level of caution and discretion in
        doing so. When you click on any of the Third-Party Links & Ads, the
        applicable third party’s terms and policies apply, including the third
        party’s privacy and data gathering practices. You should make whatever
        investigation you feel necessary or appropriate before proceeding with
        any transaction in connection with such Third-Party Links & Ads.
      </p>
      <p>
        5.2 Other Users. Each Site and Service user is solely responsible for
        any and all of its own User Content. Because we do not control User
        Content, you acknowledge and agree that we are not responsible for any
        User Content, whether provided by you or by others. We make no
        guarantees regarding the accuracy, currency, suitability, or quality of
        any User Content. Your interactions with other Site and Service users
        are solely between you and such users. You agree that Company will not
        be responsible for any loss or damage incurred as the result of any such
        interactions. If there is a dispute between you and any Site or Service
        user, we are under no obligation to become involved.
      </p>
      <p>
        5.3 Release. You hereby release and forever discharge the Company (and
        our directors, officers, employees, contractors, affiliates,
        representatives, agents, successors, and assigns) from, and hereby waive
        and relinquish, each and every past, present and future dispute, claim,
        controversy, demand, right, obligation, liability, action and cause of
        action of every kind and nature (including personal injuries, death, and
        property damage), that has arisen or arises directly or indirectly out
        of, or that relates directly or indirectly to, the Site or Services
        (including any interactions with, or act or omission of, other Site
        users or any Third-Party Links & Ads). IF YOU ARE A CALIFORNIA RESIDENT,
        YOU HEREBY WAIVE CALIFORNIA CIVIL CODE SECTION 1542 IN CONNECTION WITH
        THE FOREGOING, WHICH STATES: “A GENERAL RELEASE DOES NOT EXTEND TO
        CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR
        HER FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR
        HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE
        DEBTOR.”
      </p>
      <p>
        5.4 Third Party Beneficiaries. You agree that, except as otherwise
        expressly provided in these Terms, there shall be no third party
        beneficiaries to the Terms. The Terms of Use will not be construed as
        creating or implying any relationship of agency, franchise, partnership,
        or joint venture between you and Company, except and solely to the
        extent expressly stated in these Terms.
      </p>
      <p className="termsUpper mt-3">
        <b>6. DISCLAIMERS</b>
      </p>
      <p>
        THE SITE AND SERVICES ARE PROVIDED ON AN “AS-IS” AND “AS AVAILABLE”
        BASIS, AND COMPANY (AND OUR SUPPLIERS) EXPRESSLY DISCLAIM ANY AND ALL
        WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR
        STATUTORY, INCLUDING ALL WARRANTIES OR CONDITIONS OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT, ACCURACY, OR
        NON-INFRINGEMENT. WE (AND OUR SUPPLIERS) MAKE NO WARRANTY THAT THE SITE
        AND SERVICES WILL MEET YOUR REQUIREMENTS, WILL BE AVAILABLE ON AN
        UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS, OR WILL BE ACCURATE,
        RELIABLE, FREE OF VIRUSES OR OTHER HARMFUL CODE, COMPLETE, LEGAL, OR
        SAFE. IF APPLICABLE LAW REQUIRES ANY WARRANTIES WITH RESPECT TO THE SITE
        OR SERVICES, ALL SUCH WARRANTIES ARE LIMITED IN DURATION TO NINETY (90)
        DAYS FROM THE DATE OF FIRST USE. SOME JURISDICTIONS DO NOT ALLOW THE
        EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO
        YOU. SOME JURISDICTIONS DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED
        WARRANTY LASTS, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU.
      </p>
      <p className="termsUpper mt-3">
        <b>7. FURTHER DISCLAIMERS</b>
      </p>
      <p>
        Without limiting the generality of Section 6, neither Company nor its
        affiliates or licensors will have any responsibilities or liability with
        respect to the following: (a) the Services could be impacted by one or
        more regulatory inquiries or actions, which could prevent or limit the
        ability of Company to continue to develop or provide the Services, or
        for you and your users to use the Services, (b) Company has no
        obligation to update the Services or its underlying platforms and
        networks to address, mitigate, or remediate any security or other
        vulnerabilities in the Services, or such platforms or networks, and (c)
        portions of the Services or any other underlying networks and platforms
        may rest on open-source software, and there is a risk that weaknesses or
        bugs that may be introduced in the infrastructural elements of the
        Services or any other underlying networks and platforms, which may
        result in security vulnerabilities, data loss, damage, destructions,
        disclosure, or other compromises.
      </p>
      <p className="termsUpper mt-3">
        <b>8. LIMITATION LIABILITY</b>
      </p>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL COMPANY (OR
        OUR SUPPLIERS) BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY LOST PROFITS,
        LOST DATA, COSTS OF PROCUREMENT OF SUBSTITUTE PRODUCTS, OR ANY INDIRECT,
        CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES
        ARISING FROM OR RELATING TO THESE TERMS OR YOUR USE OF, OR INABILITY TO
        USE, THE SITE OR SERVICES, EVEN IF COMPANY HAS BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES. ACCESS TO, AND USE OF, THE SITE OR SERVICES
        IS AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE
        FOR ANY DAMAGE TO YOUR DEVICE OR COMPUTER SYSTEM, OR LOSS OF DATA
        RESULTING THEREFROM. TO THE MAXIMUM EXTENT PERMITTED BY LAW,
        NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY
        TO YOU FOR ANY DAMAGES ARISING FROM OR RELATED TO THIS AGREEMENT (FOR
        ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION), WILL AT
        ALL TIMES BE LIMITED TO A MAXIMUM OF ONE US DOLLAR (U.S. $1). THE
        EXISTENCE OF MORE THAN ONE CLAIM WILL NOT ENLARGE THIS LIMIT. YOU AGREE
        THAT OUR SUPPLIERS WILL HAVE NO LIABILITY OF ANY KIND ARISING FROM OR
        RELATING TO THIS AGREEMENT. SOME JURISDICTIONS DO NOT ALLOW THE
        LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL
        DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
      </p>
      <p className="termsUpper mt-3">
        <b>9. CRYPTOGRAPHIC SYSTEMS</b>
      </p>
      <p>
        You acknowledge and understand that cryptography is a progressing field.
        Advances in code cracking or technical advances such as the development
        of quantum computers may present risks to cryptographic systems and the
        Services, which could result in the theft or loss of your property. To
        the extent possible, the Company intends to update the code underlying
        the Services to account for any advances in cryptography and to
        incorporate additional security measures, but does not guarantee or
        otherwise represent full security of the system. By using the Services,
        you acknowledge these inherent risks.
      </p>
      <p className="termsUpper mt-3">
        <b>10. PLATFORM SECURITY</b>
      </p>
      <p>
        We are an early stage platform. You acknowledge that applications are
        code subject to flaws and acknowledge that you are solely responsible
        for evaluating any available code provided by the Services. You further
        expressly acknowledge and represent that applications can be written
        maliciously or negligently, that we cannot be held liable for your
        interaction with such applications. These warnings and others later
        provided by us in no way evidence or represent an ongoing duty to alert
        you to all of the potential risks of utilizing the Site and Services.
      </p>
      <p className="termsUpper mt-3">
        <b>11. COPYRIGHT INFRINGEMENT</b>
      </p>
      <p>
        If you believe that your copyright or the copyright of a person on whose
        behalf you are authorized to act has been infringed, please provide
        Company a written notice containing the following information: (a) an
        electronic or physical signature of the person authorized to act on
        behalf of the owner of the copyright or other intellectual property
        interest, (b) a description of the copyrighted work or other
        intellectual property that you claim has been infringed, and (c) a
        description of where the material that you claim is infringing is
        located on the Site.
      </p>
      <p>
        <br></br>Company can be reached at:<br></br>
        Email: hello@wavwrld.com<br></br>
        Subject Line: Copyright Notification: WavGAME
      </p>
      <p className="termsUpper mt-3">
        <b>12. TERM & TERMINATION</b>
      </p>
      <p>
        Subject to this Section, these Terms will remain in full force and
        effect while you use the Site. We may suspend or terminate your rights
        to use the Site and Services at any time for any reason at our sole
        discretion, including for any use of the Site or Services in violation
        of these Terms. Upon termination of your rights under these Terms, your
        right to access and use the Site and Services will terminate
        immediately. You understand that any such termination may involve
        deletion of your User Content. Company will not have any liability
        whatsoever to you for any termination of your rights under these Terms,
        including for deletion of your User Content. Even after your rights
        under these Terms are terminated, the following provisions of these
        Terms will remain in effect: Sections 2.2 through 2.5, Sections 3
        through 8, and Sections 11 through 14.{" "}
      </p>
      <p className="termsUpper mt-3">
        <b>13. COPYRIGHT INFRINGEMENT</b>
      </p>
      <p>
        {" "}
        Changes. These Terms are subject to occasional revision, and if we make
        any changes, we will change the Last Updated date above. Continued use
        of our Site and Services following such notice of such changes shall
        indicate your acknowledgement of such changes and agreement to be bound
        by the terms and conditions of such changes..
      </p>
      <p>
        {" "}
        Dispute Resolution. Please read this Arbitration Agreement (the
        “Arbitration Agreement”) carefully. It is part of your contract with
        Company and affects your rights. It contains procedures for MANDATORY
        BINDING ARBITRATION AND A CLASS ACTION WAIVER.
      </p>
      <p>
        <br></br> (a) <br></br> Applicability of Arbitration Agreement. All
        claims and disputes (excluding claims for injunctive or other equitable
        relief as set forth below) in connection with the Terms or the use of
        any product or service provided by the Company that cannot be resolved
        informally or in small claims court shall be resolved by binding
        arbitration on an individual basis under the terms of this Arbitration
        Agreement. Unless otherwise agreed to, all arbitration proceedings shall
        be held in English. This Arbitration Agreement applies to you and the
        Company, and to any subsidiaries, affiliates, agents, employees,
        predecessors in interest, successors, and assigns, as well as all
        authorized or unauthorized users or beneficiaries of services or goods
        provided under the Terms.
        <br></br> (b) <br></br> Notice Requirement and Informal Dispute
        Resolution . Before either party may seek arbitration, the party must
        first send to the other party a written Notice of Dispute ( “Notice” )
        describing the nature and basis of the claim or dispute, and the
        requested relief. A Notice to the Company should be sent to: add
        physical mail address of WavWRLD here. After the Notice is received, you
        and the Company may attempt to resolve the claim or dispute informally.
        If you and the Company do not resolve the claim or dispute within thirty
        (30) days after the Notice is received, either party may begin an
        arbitration proceeding. The amount of any settlement offer made by any
        party may not be disclosed to the arbitrator until after the arbitrator
        has determined the amount of the award, if any, to which either party is
        entitled.
        <br></br> (c) <br></br> Arbitration Rules . This Agreement shall be
        governed by the laws of the State of New York. Any claim, dispute, or
        controversy (“Claim”) arising out of or relating to this Agreement or
        the relationships among the parties hereto shall be resolved by one
        arbitrator through binding arbitration conducted in accordance with the
        expedited procedures set forth in the JAMS Comprehensive Arbitration
        Rules and Procedures (the “Rules”) as those Rules exist on the effective
        date of this Agreement, including Rules 16.1 and 16.2 of those Rules.
        The arbitrator’s decision shall be final, binding, and non-appealable.
        Judgment upon the award may be entered and enforced in any court having
        jurisdiction. This clause is made pursuant to a transaction involving
        interstate commerce and shall be governed by the Federal Arbitration
        Act. Neither party shall sue the other party other than as provided
        herein or for enforcement of this clause or of the arbitrator’s award;
        any such suit may be brought only in a Federal District Court or a New
        York state court located in New York County, New York. The arbitrator,
        and not any federal, state, or local court, shall have exclusive
        authority to resolve any dispute relating to the interpretation,
        applicability, unconscionability, arbitrability, enforceability, or
        formation of this Agreement including any claim that all or any part of
        the Agreement is void or voidable.
        <br></br> (d) <br></br> Additional Rules for Non-Appearance Based
        Arbitration . If non-appearance based arbitration is elected, the
        arbitration shall be conducted by telephone, online and/or based solely
        on written submissions; the specific manner shall be chosen by the party
        initiating the arbitration. The arbitration shall not involve any
        personal appearance by the parties or witnesses unless otherwise agreed
        by the parties.
        <br></br> (e) <br></br> Time Limits. If you or the Company pursue
        arbitration, the arbitration action must be initiated and/or demanded
        within the statute of limitations (i.e., the legal deadline for filing a
        claim) and within any deadline imposed under the Rules for the pertinent
        claim.
        <br></br> (f) <br></br> Authority of Arbitrator . If arbitration is
        initiated, the arbitrator will decide the rights and liabilities, if
        any, of you and the Company, and the dispute will not be consolidated
        with any other matters or joined with any other cases or parties. The
        arbitrator shall have the authority to grant motions dispositive of all
        or part of any claim. The arbitrator shall have the authority to award
        monetary damages, and to grant any non-monetary remedy or relief
        available to an individual under applicable law, the Rules, and the
        Terms. The arbitrator shall issue a written award and statement of
        decision describing the essential findings and conclusions on which the
        award is based, including the calculation of any damages awarded. The
        arbitrator has the same authority to award relief on an individual basis
        that a judge in a court of law would have. The award of the arbitrator
        is final and binding upon you and the Company.
        <br></br> (g) <br></br> Waiver of Jury Trial. THE PARTIES HEREBY WAIVE
        THEIR CONSTITUTIONAL AND STATUTORY RIGHTS TO GO TO COURT AND HAVE A
        TRIAL IN FRONT OF A JUDGE OR A JURY, instead electing that all claims
        and disputes shall be resolved by arbitration under this Arbitration
        Agreement. Arbitration procedures are typically more limited, more
        efficient and less costly than rules applicable in a court and are
        subject to very limited review by a court. In the event any litigation
        should arise between you and the Company in any state or federal court
        in a suit to vacate or enforce an arbitration award or otherwise, YOU
        AND THE COMPANY WAIVE ALL RIGHTS TO A JURY TRIAL, instead electing that
        the dispute be resolved by a judge.
        <br></br> (h) <br></br> Waiver of Class or Consolidated Actions . ALL
        CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION AGREEMENT MUST
        BE ARBITRATED OR LITIGATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS
        BASIS, AND CLAIMS OF MORE THAN ONE CUSTOMER OR USER CANNOT BE ARBITRATED
        OR LITIGATED JOINTLY OR CONSOLIDATED WITH THOSE OF ANY OTHER CUSTOMER OR
        USER.
        <br></br> (i) <br></br> Confidentiality . All aspects of the arbitration
        proceeding, including but not limited to the award of the arbitrator and
        compliance therewith, shall be strictly confidential. The parties agree
        to maintain confidentiality unless otherwise required by law. This
        paragraph shall not prevent a party from submitting to a court of law
        any information necessary to enforce this Agreement, to enforce an
        arbitration award, or to seek injunctive or equitable relief.
        <br></br>(j) <br></br> Severability . If any part or parts of this
        Arbitration Agreement are found under the law to be invalid or
        unenforceable by a court of competent jurisdiction, then such specific
        part or parts shall be of no force and effect and shall be severed and
        the remainder of the Agreement shall continue in full force and effect.
        <br></br>(k) <br></br> Right to Waive. Any or all of the rights and
        limitations set forth in this Arbitration Agreement may be waived by the
        party against whom the claim is asserted. Such waiver shall not waive or
        affect any other portion of this Arbitration Agreement.
        <br></br>(l) <br></br> Survival of Agreement. This Arbitration Agreement
        will survive the termination of your relationship with Company.
        <br></br>(m) <br></br> Small Claims Court. Notwithstanding the
        foregoing, either you or the Company may bring an individual action in
        small claims court.
        <br></br>(n) <br></br> Emergency Equitable Relief . Notwithstanding the
        foregoing, either party may seek emergency equitable relief before a
        state or federal court in order to maintain the status quo pending
        arbitration. A request for interim measures shall not be deemed a waiver
        of any other rights or obligations under this Arbitration Agreement.
        <br></br>(o) <br></br> Claims Not Subject to Arbitration.
        Notwithstanding the foregoing, claims of defamation, violation of the
        Computer Fraud and Abuse Act, and infringement or misappropriation of
        the other party’s patent, copyright, trademark or trade secrets shall
        not be subject to this Arbitration Agreement.
        <br></br>(p) <br></br> Courts. In any circumstances where the foregoing
        Arbitration Agreement permits the parties to litigate in court, the
        parties hereby agree to submit to the personal jurisdiction of the
        courts located within Kings County, New York, for such purpose
      </p>
      <p>
        13.3 Export. The Site may be subject to U.S. export control laws and may
        be subject to export or import regulations in other countries. You agree
        not to export, re-export, or transfer, directly or indirectly, any U.S.
        technical data acquired from Company, or any products utilizing such
        data, in violation of the United States export laws or regulations.
      </p>
      <p>
        13.4 Disclosures. If you are a California resident, you may report
        complaints to the Complaint Assistance Unit of the Division of Consumer
        Product of the California Department of Consumer Affairs by contacting
        them in writing at 400 R Street, Sacramento, CA 95814, or by telephone
        at (800) 952-5210.
      </p>
      <p>
        13.5 Electronic Communications. The communications between you and
        Company use electronic means, whether you use the Site or send us
        emails, or whether Company posts notices on the Site or communicates
        with you via email. For contractual purposes, you (a) consent to receive
        communications from Company in an electronic form; and (b) agree that
        all terms and conditions, agreements, notices, disclosures, and other
        communications that Company provides to you electronically satisfy any
        legal requirement that such communications would satisfy if it were be
        in a hard-copy writing. The foregoing does not affect your non-waivable
        rights.
      </p>
      <p>
        13.6 Entire Terms. These Terms constitute the entire agreement between
        you and us regarding the use of the Site and Services. Our failure to
        exercise or enforce any right or provision of these Terms shall not
        operate as a waiver of such right or provision. The section titles in
        these Terms are for convenience only and have no legal or contractual
        effect. The word “including” means “including without limitation”. If
        any provision of these Terms is, for any reason, held to be invalid or
        unenforceable, the other provisions of these Terms will be unimpaired
        and the invalid or unenforceable provision will be deemed modified so
        that it is valid and enforceable to the maximum extent permitted by law.
        Your relationship to Company is that of an independent contractor, and
        neither party is an agent or partner of the other. These Terms, and your
        rights and obligations herein, may not be assigned, subcontracted,
        delegated, or otherwise transferred by you without Company’s prior
        written consent, and any attempted assignment, subcontract, delegation,
        or transfer in violation of the foregoing will be null and void. Company
        may freely assign these Terms. The terms and conditions set forth in
        these Terms shall be binding upon assignees.
      </p>
      <br></br>
      <p>
        13.7 Contact. We welcome your comments or questions about these Terms.
        Please contact us at: <b>hello@wavwrld.com</b>
      </p>
      <p className="termsUpper mt-3 mb-5">
        <b>12. TERM & TERMINATION</b>
      </p>
      <p className="text-xl font-extrabold mt-12">Privacy Policy</p>
      <p>
        Last updated: June 27, 2023<br></br>
        This Privacy Policy (“Policy”) informs you of wavWRLD’s (“wavWRLD”,
        “we”, “us”, “our”) policies regarding the collection, use and disclosure
        of Personal information (defined below) when you use our websites,
        mobile applications, social media sites and handles, and receive emails
        we send (collectively our “Services”). By using the Service, you
        acknowledge that the collection and use of information is subject to
        this Policy.
      </p>
      <p className="termsUpper mt-3">
        <b> Information Collection</b>
      </p>
      <p>
        We collect both personal and anonymous information through our Services.
        Personal information includes information that can allow someone to
        identify you individually, including, for example, your name, email
        address, as well as any other non-public information about you that is
        associated with or linked to any of this identifiable information.
        Anonymous information include data that is aggregated and/or
        de-identified data, that is not associated with or linked to your
        personal information and typically cannot by itself identify individual
        persons. We collect personal information and anonymous information as
        described below. You may not always need to provide us with personal
        information in order to browse our Service. However, if you do not
        provide the personal information that is necessary, we may not be able
        to respond to your query or provide certain Services to you.
      </p>
      <p>
        <b>Types of Information Collected</b>
      </p>
      <p>
        Depending on how you interact with the Services, we may collect the
        following personal information about or from you: Personal information
        and contact information, such as your name, e-mail address, username,
        wallet address, wallet type, profile picture and any other information
        you submit through the sign-up form when you register for an account.
        Communications between you and us. When you communicate with us, such as
        through e-mail or text message, we may collect and save a record of your
        communication and any Personal information provided during the
        communication. Settings and preferences that you may set through our
        Services. Usage data and automatically collected technical information
        such as status during the WavGAME, traffic data, location data, logs,
        and other communication data and the resources that you access and use
        on the Services. Information about your computer and internet
        connection, including, but not limited to, the type of device you use,
        the IP address of your device, your operating system, the type of
        Internet browser you use, unique device identifiers and other diagnostic
        data. Other data that we may collect from you where you voluntarily
        provide it or where we provide notice that information is being
        collected.
      </p>
      <p className="termsUpper mt-3">
        <b>Sources of Information</b>
      </p>
      <p>
        We collect Information from various sources including data directly from
        you, from third parties, from public sources, and from automated
        systems. Direct interactions. You may give us your personal information
        by filling in forms or by corresponding with us by post, email or
        otherwise. This includes data you provide when you: sign up for our
        Services; signing in to your wallet to access the Services; engage
        customer support; give us feedback or contact us. Information We Collect
        from Third Parties. We may collect personal information about you from
        third-party sources. We may also collected and also anonymous or
        aggregated information from third-party sources (which may be combined
        with other personal information we have collected about you), such as:
        Blockchain: we collect certain personal information about you that is
        publicly available on a decentralized public ledger, including your
        wallet types, amounts of digital assets you possess and account
        balances. Publically available sources: We may collect information from
        publicly available sources such as public databases. Third party
        partners: We may also receive information from business partners,
        enforcement partners, and other third parties we work with, including
        wallet providers. Automated technologies or interactions. As you
        interact with our Services, we may automatically collect technical data
        about your equipment, browsing actions and patterns, and frequency of
        use. We collect this information by using cookies and other similar
        technologies. Please see below for further details.
      </p>
      <p className="termsUpper mt-3">
        <b>Retention of Personal Information</b>
      </p>
      <p>
        Except to the extent prohibited by law or as otherwise stated in this
        Policy or at the time of collection, and subject to this Policy, we will
        retain and use your Personal information for as long as it is needed for
        fulfil the purposes related to your use of the Services and the purposes
        described in this Policy. These purposes include providing you with any
        of our Services, communications, information you have requested, or
        access to the Services, to document our business relationship with you,
        and as necessary to comply with our legal obligations, prevent fraud and
        abuse, resolve disputes, and enforce our agreements. We may continue to
        retain your personal information even after you deactivate your account
        and/or cease to use the Services for the reasons described in this
        Policy. Please note that the nature of blockchain services is that
        certain data cannot be deleted or erased.
      </p>
      <p className="termsUpper mt-3">
        <b>Use of Information</b>
      </p>
      <p>
        We use the information that we collect for various purposes, including:
        <br></br>•To provide you with our Service, including helping you
        participate in the wavGAME, keeping a record of your NFTs and
        activities, and providing you notifications you have requested.
        <br></br>•To allow you to purchase NFTs;
        <br></br>•To set up and maintain your account.
        <br></br>•To respond to your inquires, requests, and questions.
        <br></br>•To notify you about changes to our Service, news about our
        Services and new features or offerings, and administrative
        notifications.
        <br></br>•To allow you to participate in interactive features of our
        Service when you choose to do so.
        <br></br>•To verify your identity and eligibility to use the Services.
        <br></br>•To improve the administration of our Service and your
        experience.
        <br></br>•To provide customer support.
        <br></br>•To gather analysis or valuable information so that we can
        improve our Service.
        <br></br>•To monitor the usage of our Service.
        <br></br>•To monitor the frequency with which you use our Service.
        <br></br>•To investigate, detect, prevent and address fraud, abuse,
        technical issues, violations of our terms, policies, and agreements, and
        other harmful or unlawful activities.
        <br></br>•To comply with applicable laws, cooperate with investigations
        by law enforcement or other authorities of suspected violations of law,
        and/or to pursue or defend against legal threats and/or claims.
        <br></br>•To provide you with news, special offers and general
        information about other goods, services and events which we offer that
        are similar to those that you have already purchased or enquired about
        unless you have opted not to receive such information. For reasons that
        we may describe to you at the time of collection. We may create
        anonymous or aggregated information from personal information so that it
        is no longer personal information. We use this anonymous information to
        analyse use of our Services and improve our Service and other offerings.
        We reserve the right to use anonymous information for any legal purpose
        and to disclose anonymous information to third parties without
        restriction, except where it may be prohibited by applicable law.
      </p>
      <p className="termsUpper mt-3">
        <b>Disclosure of Information</b>
      </p>
      <p>
        Certain of your activity is visible to all users of our Services and to
        the public, including your profile name and address, avatar, your
        collection information, including NFTs collected and amounts spent, and
        the artists you have backed. By virtue of the public nature of the
        blockchain, the holdings and transactions associated with your wallet
        address will be publicly available and accessible to third parties. We
        may also share information in the following circumstances:
      </p>
      <p className="termsUpper mt-3">
        <b>Service Providers or Processors</b>
      </p>
      <p>
        We may disclose information to third-party service providers or
        contractors (processors) who use this information to perform services
        for us, such as hosting providers, auditors, advisors, consultants,
        customer service and/or support providers and other similar service
        providers.
      </p>
      <p className="termsUpper mt-3">
        <b>Advertising and Marketing Partners</b>
      </p>
      <p>
        We may share information with third parties that provide advertising,
        campaign measurement, promotions, online and/or mobile analytics, and
        related services. These third parties may receive or access browsing
        and/or other data about your use of the Services, in order to measure
        our ad campaigns, and/or to better understand how individuals interact
        with our Services.
      </p>
      <p className="termsUpper mt-3">
        <b></b>
      </p>
      <p></p>
      <p className="termsUpper mt-3">
        <b>Law Enforcement</b>
      </p>
      <p>
        Under certain circumstances, we may be required to disclose your
        information if required to do so by law or in response to valid requests
        by public authorities (e.g. a court or a government agency).
      </p>
      <p className="termsUpper mt-3">
        <b>Legal Requirements</b>
      </p>
      <p>
        We may disclose your information to law enforcement, government
        officials, or other third parties when we believe that disclosure is
        necessary to comply with a legal obligation (such as a court order,
        warrant, or subpoena), to prevent or investigate fraud, abuse, possible
        wrongdoing in connection the Service, prevent physical or financial
        loss, or to protect against legal liability.
      </p>
      <p className="termsUpper mt-3">
        <b>Business Transfers</b>
      </p>
      <p>
        We may share some or all of your information in preparation for, during
        negotiation of, or in the process of any merger, financing, acquisition,
        or dissolution transaction or proceeding involving sale, transfer,
        divestiture, or disclosure of all or a portion of our business or
        assets. We might also transfer or share information in the event of an
        insolvency, bankruptcy, or receivership.
      </p>
      <p className="termsUpper mt-3">
        <b>Protect our Rights and our Users</b>
      </p>
      <p>
        We may disclose Personal information where we believe it necessary to
        respond to claims asserted against us, to enforce or administer our
        agreements, terms, and policies, for fraud prevention, risk assessment,
        investigation and/or to protect our rights, property, or safety and that
        of our affiliates, partners, clients, customers, users and/or others.
      </p>
      <p className="termsUpper mt-3">
        <b>Other Disclosures</b>
      </p>
      <p>
        We may disclose information to other parties and for other purposes
        based on (a) your consent, (b) at your direction, (c) as described to
        you at the time the information is collected.
      </p>
      <p className="text-xl termsUpper mt-3">
        <b>Cookies and Analytics</b>
      </p>
      <p>
        We use cookies, pixels, tags, and other technologies, which may be
        provided by third parties, on our Services to enable certain
        functionality and for security and fraud detection and prevention, as
        well as to collect usage information about our Website and the emails
        that we send and to personalize content and provide more relevant ads
        and information. We may combine the information we collect via these
        technologies with other information, including Personal information.
        Cookies. Cookies are alphanumeric identifiers that are transferred to
        your computer through your web browser for record-keeping purposes. Some
        cookies enable you to log-in to our Services or save certain settings
        and preferences, while others allow us to track usage and activities on
        our Services, personalize content, or deliver more relevant ads. Most
        web browsers automatically accept cookies, but if you prefer, you can
        edit your browser options to block them in the future. The "Help" tab on
        the toolbar on most browsers will tell you how to prevent your computer
        from accepting new cookies, how to have the browser notify you when you
        receive a new cookie, or how to disable cookies altogether. If you block
        cookies, however, certain features on our Website may not be available
        or function properly.
        <br></br>Third parties may use cookies and other similar technologies to
        collect or receive information from our Site and elsewhere on the
        Internet and use that information to provide you with targeted ads. If
        you would like to opt-out of such advertising practices on the
        particular device on which you are accessing this Privacy Policy, please
        see the “Your Choices” section below. Note that opting-out does not mean
        you will no longer receive online advertising. It does mean that the
        company or companies from which you opted-out will no longer deliver ads
        tailored to your preferences and usage patterns. Opt outs are also
        device and browser specific.
        <br></br>Pixel tags and embedded script (aka clear GIFs and web
        beacons).
        <br></br>Pixel tags are tiny graphics with a unique identifier, similar
        in function to cookies. In contrast to cookies, which are stored on your
        computer’s hard drive, pixel tags are embedded invisibly on web pages.
        We may use these, in connection with our Website to, among other things,
        track the activities of the users of our Services, improve ads,
        personalize and manage content, and gather usage information about our
        Website. We may also use these in HTML emails to help us track email
        response rates, identify when our emails are viewed, and track whether
        our emails are forwarded.
        <br></br>Third-Party Analytics Tools. Our Website uses automated devices
        and applications operated by third parties, such as Google Analytics,
        which uses cookies and similar technologies to collect and analyze
        information about use of the Website and report on activities and
        trends. This service may also collect information regarding the use of
        other websites, apps and online resources. You can learn about Google's
        practices by going to www.google.com/policies/privacy/partners/, and you
        can opt out of them by downloading the Google Analytics opt-out browser
        add-on, available at https://tools.google.com/dlpage/gaoptout
      </p>
      <p className="termsUpper mt-3">
        <b>Security of Data</b>
      </p>
      <p>
        the Internet or method of electronic storage is 100% secure. While we
        strive to use commercially acceptable means to protect your Personal
        information, we cannot guarantee its absolute security.
      </p>
      <p className="termsUpper mt-3">
        <b>Links to Other Sites and Platforms</b>
      </p>
      <p>
        When you use our Service, you have the option to link to a third-party
        wallet which allows you to engage in transactions on public blockchains.
        Your interactions with any third-party wallet provider are governed by
        the applicable terms and privacy policy of that third party. You may
        also engage in transactions to purchase NFTs on third party sites, your
        interactions on those third party NFT marketplaces are governed by the
        marketplace’s terms and privacy policies. Our Service may contain links
        to other websites, plug-ins and applications that are not operated by
        us. If you click a third party link, you will be directed to that third
        party's site, which may allow third parties to collect or share data
        about you. We strongly advise you to review the privacy policy of every
        site you visit. We have no control over and assume no responsibility for
        the content, privacy policies or practices of any third party sites or
        services.
      </p>
      <p className="termsUpper mt-3">
        <b>Children's Privacy</b>
      </p>
      <p>
        Our services are not offered to children and we do not knowingly collect
        personally identifiable information from anyone under the age of 18 (or
        majority in the jurisdiction they are accessing the services from). If
        you are a parent or guardian and you are aware that your child has
        provided us with Personal information, please contact us. If we become
        aware that we have collected Personal information from children without
        verifiable parental consent, we will take steps to remove that
        information from our servers.
      </p>
      <p className="termsUpper mt-3">
        <b>Do Not Track</b>
      </p>
      <p>
        We do not currently recognize automated browser signals regarding
        tracking mechanisms, which may include “Do Not Track” (DNT) signals sent
        by web browsers, mobile devices, or other mechanisms. Third parties may
        be able to collect information, including Personal information, about
        your online activities over time and across different websites or online
        services when you use the Services. You may opt out of online behavioral
        ads at http://www.aboutads.info/choices/. You also may limit certain
        tracking by disabling cookies in your web browser.
      </p>
      <p className="termsUpper mt-3">
        <b>Users Outside of the United States.</b>
      </p>
      <p>
        If you access the Service from outside of the United States, by visiting
        the Service and providing us with data, you acknowledge and agree that
        your personal information may be processed for the purposes identified
        in the Privacy Policy. In addition, your personal information may be
        processed in the country in which it was collected and in other
        countries, including the United States, where laws regarding processing
        of personal information may be less stringent than the laws in your
        country. By providing your personal information, you consent to such
        transfer.
      </p>
      <p className="termsUpper mt-3">
        <b>Jurisdiction Specific Notices</b>
      </p>
      <p>
        If you are a resident of specific states you have additional rights
        described below:
        <br></br>California Residents Where applicable, California Civil Code
        Section 1798.83 allows California residents to request certain
        information regarding our disclosure of Personal information to third
        parties for their direct marketing purposes. To make such a request
        please contact us using the information provided in the Contact Us
        section below.
        <br></br>Nevada Residents If you are a resident of Nevada, you have the
        right to opt-out of the sale of certain Personal information to third
        parties who intend to license or sell that Personal information. You can
        exercise this right by contacting us at hello@wavwrld.com with the
        subject line “Nevada Do Not Sell Request” and providing us with your
        name and the email address associated with your account. Please note
        that we do not currently sell your Personal information as sales are
        defined in Nevada Revised Statutes Chapter 603A. If you have any
        questions, please contact us as set forth below.
      </p>
      <p className="termsUpper mt-3">
        <b>Changes to This Privacy Policy</b>
      </p>
      <p>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page. Please
        check the “effective date” at the top of this Privacy Policy If required
        by applicable law, we will let you know via email and/or a prominent
        notice on our Service, prior to any significant changes becoming
        effective and update the "effective date" at the top of this Privacy
        Policy. You are advised to review this Privacy Policy periodically for
        any changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </p>
      <p className="text-xl termsUpper mt-3">
        <b>Contacting us</b>
      </p>
      <p>
        If you have any questions about this Policy, please contact us using our
        email address: <b>hello@wavwrld.com</b>
      </p>
    </div>
  );
};
